import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
// import RefreshIcon from '../../assets/refresh.svg';
import ThumbsDownIcon from '../../assets/thumbsDown.svg';
import ThumbsDownIconSelected from '../../assets/thumbsDownSelected.svg';
import ThumbsUpIcon from '../../assets/thumbsUp.svg';
import ThumbsUpIconSelected from '../../assets/thumbsUpSelected.svg';
import InsightHistoryIcon from '../../assets/callInsightsHistory.svg';
import { selectCurrentEmpid, selectCurrentUserManagerLevel } from '../../pages/login/authSlice';
import {
    useCreateCoachingInsightFeedbackMutation,
    useGetCoachingInsightFeedbackQuery,
} from '../coachingInsight/CoachingInsightSlice';
import './CoachingInsightSummary.scss';
import { formatWeekRange } from '../coachingInsight/coachingInsightFeedback/coaching-Insight-Feedback-service';
import { formatDate2 } from '../../utils/dateFormat';
import { ROLES } from '../../constants';


interface CoachingInsightSummaryProps {
    data: any;
    disagreeFeedback?: string;
    setShowThumbDownFeedback?: React.Dispatch<React.SetStateAction<boolean>>;
    setThumbdownFeedbackColumn?: React.Dispatch<React.SetStateAction<string>>;
    setInsightFeedbackData?: React.Dispatch<any>;
    setShowInsightsHistoryModal?: React.Dispatch<React.SetStateAction<boolean>>;
    via?: string;
    showActionItems?: boolean;
}

export interface InsightSummaryRef {
    onThumbsDownSave: (feedbackColumn: string) => void;
}

export const CoachingInsightSummary = forwardRef<InsightSummaryRef, CoachingInsightSummaryProps>(
    ({ data, disagreeFeedback, setShowThumbDownFeedback, setThumbdownFeedbackColumn, setInsightFeedbackData, setShowInsightsHistoryModal, via, showActionItems = false }, ref) => {
        const [feedback, setFeedback] = useState<any>({});
        const [triggerUpdate, setTriggerUpdate] = useState(false);
        const loggedEmpNum = useSelector(selectCurrentEmpid);
        const [createFeedback] = useCreateCoachingInsightFeedbackMutation();
        const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
        const { data: insightFeedbackData } = useGetCoachingInsightFeedbackQuery(
            {
                coachingInsightId: data[0]?.coachingInsightId,
                authorNumber: loggedEmpNum
            },
            { skip: !(data.length > 0) || data[0]?.coachingInsightId === 0 }
        );

        useEffect(() => {
            let obj = {
                coachingInsightFeedbackId: null,
                coachingInsightId: data[0]?.coachingInsightId,
                feedbackEmployeeNumber: loggedEmpNum,
                coachingPointsRating: null,
                coachingPointsFeedback: '',
                strengthsRating: null,
                strengthsFeedback: '',
                technicalIssuesRating: null,
                technicalIssuesFeedback: '',
            };
            if (insightFeedbackData?.data?.length > 0) {
                if (setInsightFeedbackData) {
                    setInsightFeedbackData(insightFeedbackData.data[0])
                };
                const feedback = insightFeedbackData.data[0];
                obj = {
                    coachingInsightFeedbackId: feedback.coaching_insight_feedback_id,
                    coachingInsightId: data[0]?.coachingInsightId,
                    feedbackEmployeeNumber: loggedEmpNum,
                    coachingPointsRating: feedback.coaching_points_rating,
                    coachingPointsFeedback: feedback.coaching_points_feedback,
                    strengthsRating: feedback.strengths_rating,
                    strengthsFeedback: feedback.strengths_feedback,
                    technicalIssuesRating: feedback.technical_issues_rating,
                    technicalIssuesFeedback: feedback.technical_issues_feedback,
                };
            }
            setFeedback(obj);
        }, [insightFeedbackData]);
        const historyClick = () => {
            if (setShowInsightsHistoryModal) {
                setShowInsightsHistoryModal(true);
            }
        }

        const onThumbsDownSave = (feedbackColumn: string) => {
            setFeedback((prevFeedback: any) => {
                let updatedFeedback;

                switch (feedbackColumn) {
                    case 'coachingPoints':
                        updatedFeedback = {
                            ...prevFeedback,
                            coachingPointsRating: false,
                            // coachingPointsRating: prevFeedback.coachingPointsRating === null ? false : null,
                            coachingPointsFeedback: disagreeFeedback,
                        };
                        break;
                    case 'strengths':
                        updatedFeedback = {
                            ...prevFeedback,
                            strengthsRating: false,
                            // strengthsRating: prevFeedback.strengthsRating === null ? false : null,
                            strengthsFeedback: disagreeFeedback,
                        };
                        break;
                    case 'technicalIssues':
                        updatedFeedback = {
                            ...prevFeedback,
                            technicalIssuesRating: false,
                            // technicalIssuesRating: prevFeedback.technicalIssuesRating === null ? false : null,
                            technicalIssuesFeedback: disagreeFeedback,
                        };
                        break;
                    default:
                        updatedFeedback = { ...prevFeedback };
                }

                setTriggerUpdate(true); // Set the trigger to true to make the API call later
                return updatedFeedback;
            });
        };

        // Expose onThumbsDownSave to parent (CoachingInsight)
        useImperativeHandle(ref, () => ({
            onThumbsDownSave,
        }));

        const thumbsDownClick = (feedbackColumn: string) => {
            if (setThumbdownFeedbackColumn) {
                setThumbdownFeedbackColumn(feedbackColumn);
            }
            // const feedbackMapping: { [key: string]: any } = {
            //     coachingPoints: insightFeedbackData?.data[0]?.coaching_points_rating,
            //     strengths: insightFeedbackData?.data[0]?.strengths_rating,
            //     technicalIssues: insightFeedbackData?.data[0]?.technical_issues_rating,
            // };
            // const rating = feedbackMapping[feedbackColumn];
            // if (rating === false) onThumbsDownSave(feedbackColumn);
            // else 
            if (setShowThumbDownFeedback) {
                setShowThumbDownFeedback(true);
            }
        };

        const thumbsUpClick = (feedbackColumn: string) => {
            setFeedback((prevFeedback: any) => {
                let updatedFeedback;

                switch (feedbackColumn) {
                    case 'coachingPoints':
                        updatedFeedback = {
                            ...prevFeedback,
                            coachingPointsRating:
                                prevFeedback.coachingPointsRating === null ||
                                    !prevFeedback.coachingPointsRating
                                    ? true
                                    : null,
                            coachingPointsFeedback: '',
                        };
                        break;
                    case 'strengths':
                        updatedFeedback = {
                            ...prevFeedback,
                            strengthsRating:
                                prevFeedback.strengthsRating === null || !prevFeedback.strengthsRating
                                    ? true
                                    : null,
                            strengthsFeedback: '',
                        };
                        break;
                    case 'technicalIssues':
                        updatedFeedback = {
                            ...prevFeedback,
                            technicalIssuesRating:
                                prevFeedback.technicalIssuesRating === null ||
                                    !prevFeedback.technicalIssuesRating
                                    ? true
                                    : null,
                            technicalIssuesFeedback: '',
                        };
                        break;
                    default:
                        updatedFeedback = { ...prevFeedback };
                }

                setTriggerUpdate(true); // Set the trigger to true to make the API call later
                return updatedFeedback;
            });
        };

        // Use useEffect to handle the API call when feedback is updated
        useEffect(() => {
            if (triggerUpdate && feedback) {
                createFeedback(feedback)
                    .unwrap()
                    .then((res: { statusCode: number }) => {
                        if (res.statusCode === 200) {
                            toast.success('Saved successfully');
                        } else {
                            toast.error('Save failed');
                        }
                    })
                    .catch((err: any) => {
                        const errorMessage = err.message || 'An error occurred';
                        toast.error(errorMessage);
                    })
                    .finally(() => {
                        setTriggerUpdate(false); // Reset the trigger to false after the call
                    });
            }
        }, [triggerUpdate, feedback]);

        const renderThumbsUp = (feedbackColumn: string): React.ReactNode => {
            const feedbackMapping: { [key: string]: any } = {
                coachingPoints: insightFeedbackData?.data[0]?.coaching_points_rating,
                strengths: insightFeedbackData?.data[0]?.strengths_rating,
                technicalIssues: insightFeedbackData?.data[0]?.technical_issues_rating,
            };
            const rating = feedbackMapping[feedbackColumn];
            return <img src={rating ? ThumbsUpIconSelected : ThumbsUpIcon} alt="agree" />;
        };

        const renderThumbsdown = (feedbackColumn: string): React.ReactNode => {
            const feedbackMapping: { [key: string]: any } = {
                coachingInsightFeedbackId: insightFeedbackData?.data[0]?.coaching_insight_feedback_id,
                coachingPoints: insightFeedbackData?.data[0]?.coaching_points_rating,
                strengths: insightFeedbackData?.data[0]?.strengths_rating,
                technicalIssues: insightFeedbackData?.data[0]?.technical_issues_rating,
                coachingPointsFeedback: insightFeedbackData?.data[0]?.coaching_points_feedback,
                strengthsFeedback: insightFeedbackData?.data[0]?.strengths_feedback,
                technicalIssuesFeedback: insightFeedbackData?.data[0]?.technical_issues_feedback,
            };
            const rating = feedbackMapping[feedbackColumn];
            const feedbackText = feedbackMapping[`${feedbackColumn}Feedback`];
            return (
                <>
                    <img
                        src={(rating || rating === null || rating === undefined) ? ThumbsDownIcon : ThumbsDownIconSelected}
                        alt="Disagree"
                        className={`${feedbackColumn}-${feedbackMapping.coachingInsightFeedbackId}`} />
                    {(via === 'history' || via === 'feedbackHistory') && rating === false &&
                        <Tooltip target={`.${feedbackColumn}-${feedbackMapping.coachingInsightFeedbackId}`} position="top">
                            <div className="tooltip-content">
                                <span style={{ minWidth: '1rem' }}>{feedbackText}</span>
                            </div>
                        </Tooltip>}
                </>
            );
        };

        const renderFeedbackHeader = (feedbackColumn: string): React.ReactNode => {
            return (
                <div className="divFeedbackHeader">
                    {(feedbackColumn === 'coachingPoints' && via !== 'history' && via !== 'feedbackHistory') ?
                        <button onClick={historyClick} className="buttonIcon">
                            <img src={InsightHistoryIcon} alt="history" />
                        </button> : ''}
                    {(!ROLES.Agents.includes(userManagerLevel) && !data[0]?.isPartialSummary) && (
                        <><button onClick={() => thumbsUpClick(feedbackColumn)} className="buttonIcon"
                            disabled={(via === 'history' || via === 'feedbackHistory')}>
                            {renderThumbsUp(feedbackColumn)}
                        </button><button
                            onClick={() => thumbsDownClick(feedbackColumn)} className={`${feedbackColumn} buttonIcon`}
                            disabled={(via === 'history' || via === 'feedbackHistory')}>
                                {renderThumbsdown(feedbackColumn)}
                            </button></>
                    )}
                </div>
            );
        };
        const ExportFeedback = () => {
            if (data?.length > 0) {
                const feedbackArray = data.map((feedback: any) => {
                    return {
                        'Associate': feedback?.employee_name,
                        'Week': formatWeekRange(feedback),
                        'Feedback Created by': feedback?.feedback_employee_name,
                        'Create Date': feedback?.create_date ? formatDate2(feedback?.create_date) : '',
                        'Modified Date': feedback.modify_date ? formatDate2(feedback?.modify_date) : '',
                        'No. of Calls': feedback?.call_count,
                        'Coaching Points': feedback.negativeTips,
                        'Coaching Points Rating': feedback?.coaching_points_rating,
                        'Coaching Points Feedback': feedback?.coaching_points_feedback,
                        'Strengths': feedback.positiveTips,
                        'Strengths Rating': feedback?.strengths_rating,
                        'Strengths Feedback': feedback?.strengths_feedback,
                        'Technical Issues': feedback.technicalTips,
                        'Technical Issues Rating': feedback?.technical_issues_rating,
                        'Technical Issues Feedback': feedback?.technical_issues_feedback,
                    };
                });
                import('xlsx').then((xlsx) => {
                    const worksheet = xlsx.utils.json_to_sheet(feedbackArray);
                    const workbook = xlsx.utils.book_new();
                    xlsx.utils.book_append_sheet(workbook, worksheet, 'CoachingInsightFeedback');
                    xlsx.writeFile(workbook, 'CoachingInsightFeedback.xlsx');
                });
            }
        }
        return (
            <>
                {via === 'feedbackHistory' &&
                    <div className="mt-2">
                        <Button
                            type="button"
                            icon="pi pi-upload me-2"
                            className="btn-export me-2 float-end"
                            style={{ color: '#2AA154' }}
                            onClick={ExportFeedback}
                            data-pr-tooltip="XLS"
                        >
                            Export Feedback
                        </Button>
                    </div >}
                <div className="row border-top mt-2">

                    {data.map((data: any, index: number) => (
                        <React.Fragment key={index}>
                            {/* Negative Tips Summary */}
                            <div className="col-md-4 mb-4 mt-4">
                                <div className="card h-100 shadow bg-body rounded">
                                    <div className="row">
                                        <div className="col-md-7 mt-2">
                                            <h4 className="ms-2">Coaching Points</h4>
                                        </div>
                                        <div className="col-md-5">{renderFeedbackHeader('coachingPoints')}</div>
                                    </div>
                                    <div className="card-body" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                        <div
                                            className="insightsSummary"
                                            dangerouslySetInnerHTML={{ __html: data.negativeTips }} />
                                    </div>
                                </div>
                            </div>
                            {/* Positive Tips Summary */}
                            <div className="col-md-4 mb-4 mt-4">
                                <div className="card h-100 shadow bg-body rounded">
                                    <div className="row">
                                        <div className="col-md-8 mt-2">
                                            <h4 className="ms-2">Strengths</h4>
                                        </div>
                                        <div className="col-md-4">{renderFeedbackHeader('strengths')}</div>
                                    </div>
                                    <div className="card-body" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                        <div
                                            className="insightsSummary"
                                            dangerouslySetInnerHTML={{ __html: data.positiveTips }} />
                                    </div>
                                </div>
                            </div>

                            {/* Technical Tips Summary */}
                            <div className="col-md-4 mb-4 mt-4">
                                <div className="card h-100 shadow bg-body rounded">
                                    <div className="row">
                                        <div className="col-md-8 mt-2">
                                            <h4 className="ms-2">{showActionItems ? 'Action Items' : 'Technical Issues'}</h4>
                                        </div>
                                        <div className="col-md-4">{renderFeedbackHeader('technicalIssues')}</div>
                                    </div>
                                    <div className="card-body" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                        <div
                                            className="insightsSummary"
                                            dangerouslySetInnerHTML={{ __html: data.technicalTips }} />
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div></>
        );
    }
);
